import { css } from "@emotion/css";
import { socketInstant } from "App";
import { BaseResponse, DealerModel, GameDataModel, GameInstance, JoinGameResponse, LichSuPhienModel, StatsCount } from "models/gameModel";
import { useEffect, useState } from "react";
import TableCau from "components/table-cau";
import TimeCount from "./time-count";
import { RootState, useAppSelector } from "cache/store";

interface Props {
	gameInstance: GameInstance;
	historyData: LichSuPhienModel[];
	statsTotal: StatsCount;
	onPlayGame: (gameId: number) => void;
	typeGame: string;
}
export default function LiveItemMobile(props: Props) {
	const { gameInstance, historyData, statsTotal, onPlayGame, typeGame } = props;
	const [dealerInfo, setDealerInfo] = useState({} as DealerModel);
	const [gameData, setGameData] = useState({} as GameDataModel);
	const [issueUpdate, setIssueUpdate] = useState<LichSuPhienModel>(); //lịch sử phiên mới nhất
	const [result, setResult] = useState<number[] | null>(null);
	const [statsGeneral, setStatsGeneral] = useState(statsTotal);
	const [maintainMsg, setMaintainMsg] = useState<String | null>(""); //bảo trì game
	const { socketLoaded } = useAppSelector((state: RootState) => state.socket);

	useEffect(() => {
		if (statsTotal) {
			setStatsGeneral(statsTotal);
		}
	}, [statsTotal]);

	useEffect(() => {
		if (socketLoaded) {
			socketInstant.emit("game:join", { game_instance_id: gameInstance.id }, (data: BaseResponse<JoinGameResponse>) => {
				const { game, instance } = data.data;

				setDealerInfo(instance.dealer || ({} as DealerModel));
				setMaintainMsg(instance.maintenance_msg);
				setGameData(game);
			});

			//check game bao tri
			socketInstant.on("game:set-maintenance", (maintenanceMsg: string) => {
				if (maintenanceMsg) {
					setMaintainMsg(maintenanceMsg);
				} else {
					setMaintainMsg("");
				}
			});

			//event bắt đầu phiên mới
			socketInstant.on("game:start", (data: GameDataModel) => {
				console.log("bắt đầu phiên ======>", data);
				setGameData(data);
				setResult(null);
			});

			//event kết thúc phiên
			socketInstant.on("game:end", (data: any) => {
				console.log("kết thúc phiên ======>", data);
				setIssueUpdate(data);
				setResult(data.result);
				updateStatsGeneral(data.result);
			});

			//event thay đổi dealer
			socketInstant.on("game:set-dealer", (data: DealerModel) => {
				setDealerInfo(data);
			});
		}
	}, [socketLoaded]);

	const updateStatsGeneral = (result: number[]) => {
		const totalResult = result.reduce((a, b) => a + b);
		setStatsGeneral((obj) => {
			if (totalResult % 2 === 0) obj.chan += 1;
			else obj.le += 1;

			if (totalResult < 2) obj.tai += 1;
			else if (totalResult > 2) obj.xiu += 1;
			return obj;
		});
	};

	const handlePlayGame = () => {
		if (maintainMsg) return;
		onPlayGame(gameInstance.id);
	};

	return (
		<div className={styles.gameContainer} onClick={handlePlayGame}>
			<div className="game-header">
				<h4 className="game-title">{gameInstance.name}</h4>
				<div className="time-count">
					{gameData.status && gameData.setting && !maintainMsg && (
						<TimeCount gameType={gameInstance.type.id} result={result} startTime={gameData.created_at} time={gameData.setting.duration} isSecond />
					)}
				</div>
			</div>
			<div className="game-content">
				<div className="dealer-info">
					{dealerInfo.avatar ? <img src={dealerInfo.avatar} alt="" /> : <img src={require("assets/images/dealer.jpg")} alt="" />}
					{dealerInfo.nickname && <div className="dealer-name">{dealerInfo.nickname}</div>}
				</div>

				<div className="table-stats">
					<TableCau isMobile rowSetting={6} colSetting={7} typeStats={typeGame === "xd-live" ? "CHANLE" : "CHANLE_TX"} issueList={historyData} issueUpdate={issueUpdate} />
				</div>
				<div className="table-stats">
					<TableCau isMobile rowSetting={6} colSetting={7} typeStats={typeGame === "xd-live" ? "TAIXIU" : "TAIXIU_TX"} issueList={historyData} issueUpdate={issueUpdate} />
				</div>
			</div>
			<div className="game-footer">
				<div className="footer-left">
					<div className="stats-item">
						<div className="label-1 label-2">
							<span className={`${styles.textYellowGradient}`}>C</span>
						</div>
						<p>{statsGeneral ? statsGeneral.chan : 0}</p>
					</div>
					<div className="stats-item">
						<div className="label-1">
							<span className={`${styles.textYellowGradient}`}>L</span>
						</div>
						<p>{statsGeneral ? statsGeneral.le : 0}</p>
					</div>
					<div className="stats-item">
						<div className="label-1">
							<span className={`${styles.textYellowGradient}`}>T</span>
						</div>
						<p>{statsGeneral ? statsGeneral.tai : 0}</p>
					</div>
					<div className="stats-item">
						<div className="label-1 label-2">
							<span className={`${styles.textYellowGradient}`}>X</span>
						</div>
						<p>{statsGeneral ? statsGeneral.xiu : 0}</p>
					</div>
				</div>
				{/* <button type="button" className="btn-play" onClick={() => onPlayGame(gameInstance.id)}>
                    VÀO CHƠI
                </button> */}
			</div>
			{maintainMsg && <div className="maintain-game">{maintainMsg}</div>}
		</div>
	);
}

const styles = {
	gameContainer: css`
		background: rgba(8, 11, 33, 0.8);
		padding: 6px;
		border: 1px solid #454c7c;
		border-radius: 8px;
		position: relative;
		overflow: hidden;
		margin-bottom: 4px;
		.game-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 4px;
			.game-title {
				font-weight: 500;
			}
		}
		.game-content {
			display: flex;
			gap: 2px;
			padding: 8px 0;
			border-top: 1px solid #454c7c;
			border-bottom: 1px solid #454c7c;
			.table-stats {
				flex: 1;
			}
			.dealer-info {
				flex: 1;
				max-width: 123px;
				max-height: 94px;
				position: relative;
				display: flex;
				img {
					width: 100%;
					object-fit: cover;
				}
				.dealer-name {
					position: absolute;
					bottom: 0;
					left: 0;
					background: rgba(105, 16, 232, 0.8);
					padding: 2px 12px 2px 4px;
					border-top-right-radius: 16px;
					min-width: 60px;
				}
			}
		}
		.game-footer {
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 4px;
			.footer-left {
				display: flex;
				gap: 8px;
			}
			.stats-item {
				display: flex;
				align-items: center;
				background: #141d33;
				gap: 4px;
				padding: 2px 6px;
				border-radius: 8px;
				span {
					font-weight: 700;
				}
				.label-1 {
					width: 20px;
					height: 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: 600;
					background: linear-gradient(180deg, rgba(251, 0, 4, 1) 0%, rgba(110, 0, 2, 1) 100%);
					border-radius: 40px;
				}
				.label-2 {
					background: linear-gradient(180deg, rgba(39, 78, 154, 1) 0%, rgba(0, 33, 100, 1) 100%);
				}
			}
			.btn-play {
				background: linear-gradient(180deg, rgba(11, 117, 121, 1) 0%, rgba(2, 46, 42, 1) 100%);
				color: #fff;
				padding: 10px 14px;
				border-radius: 8px;
				cursor: pointer;
			}
		}
		.maintain-game {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 4;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.7);
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 10%;
			text-align: center;
		}
	`,
	textYellowGradient: css`
		background: linear-gradient(to bottom, #fff9d7 0%, #fbae3d 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	`,
};
